module.exports = __webpack_public_path__ + "static/media/Trade_Trade_3.1367f955.png";